(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["profam"] = factory();
	else
		root["profam"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition